module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-home row",
    style: (_vm.style)
  }, [_c('v-divider', {
    staticClass: "divider-left",
    class: _vm.no_left ? 'no_left' : ''
  }), _vm._v(" "), _c('div', {
    staticClass: "title-home__text-wrapper"
  }, [_c('span', {
    staticClass: "title-home__text"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-divider', {
    staticClass: "divider-right"
  })], 1), _vm._v(" "), _c('v-divider')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b9a74bf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/text/UITitleLine.vue
// module id = 360
// module chunks = 2